import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import DashboardHeader from "../components/DashboardHeader";
import ProgressSection from "../components/ProgressSection";
import { getCourseSubjects, getUserDataCached } from "../services/userService";
import "../styles/Dashboard.css";
import Subjects from "../components/Subjects";
import { MateriaContenido } from "../components/MateriaContenido";
import { contarProgresoCurso } from "../services/progressUtils";

function Dashboard({ setIsModalOpen }) {
  const { usuario } = useAuth();
  const [datosUsuario, setDatosUsuario] = useState(null);
  const [materias, setMaterias] = useState([]);
  const [materiaSeleccionada, setMateriaSeleccionada] = useState(null);
  const [modo, setModo] = useState("dashboard");
  const [temasCurso, setTemasCurso] = useState([]);


  // 👇 único estado para el tema
  const [selectedTema, setSelectedTema] = useState(null);

  // Avisar a Layout cada vez que cambia el tema
  useEffect(() => {
    setIsModalOpen(!!selectedTema);
  }, [selectedTema, setIsModalOpen]);


  // Obtener datos del usuario
  useEffect(() => {
    refrescarDatosUsuario();
  }, [usuario]);


  const refrescarDatosUsuario = async () => {
    if (usuario) {
      const data = await getUserDataCached(usuario.uid);
      setDatosUsuario(data);

      if (data["00 Curso"]) {
        const subjects = await getCourseSubjects(data["00 Curso"]);
        const materiasCurso = subjects.filter((materia) => materia.codigo.length === 1);
        setMaterias(materiasCurso);

        const temasCursoExtraidos = materiasCurso.flatMap((materia) => {
          if (typeof materia.contenido === "string") {
            return materia.contenido.split("-").filter((codigo) => codigo.length <= 5);
          }
          if (typeof materia.contenido === "object" && materia.contenido !== null) {
            return Object.keys(materia.contenido); // los códigos de los temas
          }
          return [];
        });

        setTemasCurso(temasCursoExtraidos);
      }
    }
  };

  const progreso = contarProgresoCurso(
    datosUsuario?.["19 Calificaciones"] || {},
    temasCurso
  );

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        {datosUsuario && modo !== "cuestionario" && (
          <DashboardHeader
            user={{
              uid: usuario.uid,
              name: datosUsuario["01 Nombre"],
              photoURL: datosUsuario["06 Foto"],
              curso: datosUsuario["00 Curso"],
              rol: datosUsuario["05 Status"],
              completed: datosUsuario?.["14 TemasT"] || 0,
              datosUsuario: datosUsuario
            }}
          />
        )}
        {datosUsuario && modo !== "cuestionario" && (
          <ProgressSection completed={progreso.completed} total={177}
            datosUsuario={datosUsuario} uid={usuario.uid} />
        )}
      </header>

      <div>
        {datosUsuario && (
          <Subjects
            materias={materias}
            calificaciones={datosUsuario["19 Calificaciones"] || {}}
            materiaSeleccionada={materiaSeleccionada}
            setMateriaSeleccionada={setMateriaSeleccionada}
            selectedTema={selectedTema}
            setSelectedTema={setSelectedTema}
            user={{
              uid: usuario.uid,
              rol: datosUsuario["05 Status"]
            }}
            setModo={setModo}
            refrescarDatosUsuario={refrescarDatosUsuario}
          />
        )}
      </div>
    </div>
  );
}

export default Dashboard;
